export default "__VITE_ASSET__DrT9vpkp__"